import { AccountModule } from './components/account/account.module';
import { ShoppingModule } from './components/shopping/shopping.module';
import { SharedModule } from './components/shared/shared.module';
import { ProductsModule } from './components/products/products.module';
import { AuthModule } from './components/auth/auth.module';
import { SiteModule } from './components/site/site.module';
import { LayoutModule } from './components/layout/layout.module';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthGuardService } from './components/guards/auth-guard.service';
import { CheckoutService } from './components/guards/checkout.service';
import { KycguardService } from './components/guards/kycguard.service';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    LayoutModule,
    SiteModule,
    AuthModule,
    ProductsModule,
    SharedModule,
    ShoppingModule,
    AccountModule,
    RouterModule,
    HttpClientModule,
    BrowserAnimationsModule,
  ],
  providers: [AuthGuardService,CheckoutService,KycguardService,{provide: LocationStrategy, useClass: HashLocationStrategy}],
  bootstrap: [AppComponent]
})
export class AppModule { }